import { decode, encode } from 'base-64'

import { get, set, remove } from './storage'

const KEY = 'ACC_LL'
const EMAIL = '0'
const FACEBOOK = '1'
const GOOGLE = '2'

const saveEmailLogin = ({ email }) => {
  if (email) {
    set(KEY, `${EMAIL}|${encode(email)}`)
  }
}

const saveFacebookLogin = ({ facebookId }) => {
  if (facebookId) {
    set(KEY, `${FACEBOOK}|${encode(facebookId)}`)
  }
}

const saveGoogleLogin = ({ googleId }) => {
  if (googleId) {
    set(KEY, `${GOOGLE}|${encode(googleId)}`)
  }
}

const getLastLogin = async () => {
  try {
    const value = await get(KEY)
    const [type, data] = value ? value.split('|') : [undefined, undefined]
    switch (type) {
      case EMAIL:
        return { type: 'email', id: decode(data) }
      case FACEBOOK:
        return { type: 'facebook', id: decode(data) }
      case GOOGLE:
        return { type: 'google', id: decode(data) }
      default:
        return { type: 'login' }
    }
  } catch (ex) {
    return { type: 'login' }
  }
}

const removeLastLogin = () => remove(KEY)

export default {
  saveEmailLogin,
  saveFacebookLogin,
  saveGoogleLogin,
  getLastLogin,
  removeLastLogin,
}
